import _ from 'lodash';
import React, { Component, PropTypes } from 'react';

/** This is a demo component for stylesheet */
class DummyStoryList extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array
  }

  render() {
    const {
      FRN_rawResponses: [{
        data: {
          features: items = [],
        } = {}
      }] = []
    } = this.props;

    const filteredItems = items.filter(item => _.includes(['story', 'clip', 'link'], _.toLower(item.type)));

    return (
     <div className="frn-u-background">
       <div className="frn-u-padding-sm frn-u-margin-sm frn-u-displayFont-xxl frn-u-foreground-attention frn-u-fontWeight-bold">News</div>
       {
         filteredItems.map((item, index) => {
           const { headline = '', abstract = '' } = item;

           return (
             <div key={index} className="frn-u-background-accent frn-u-padding-sm frn-u-margin-sm">
               <div className="frn-u-foreground-chrome frn-u-fontWeight-semibold frn-u-displayFont-lg frn-u-margin-xs" >{headline}</div>
               <div className="frn-u-foreground frn-u-margin-xs frn-u-fontWeight-light frn-u-displayFont-xs"
                 dangerouslySetInnerHTML={{ __html: abstract.replace(/p>/g, 'span>') }} ></div>
             </div>
           );
         })
       }
     </div>
    );
  }
}

export default DummyStoryList;



// WEBPACK FOOTER //
// ./app/components/core/DummyStoryList.js